import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';
export var bidAndWinActions;
(function (bidAndWinActions) {
    bidAndWinActions["GET_BID_AND_WIN_REQUEST"] = "GET_BID_AND_WIN_REQUEST";
    bidAndWinActions["GET_BID_AND_WIN_SUCCESS"] = "GET_BID_AND_WIN_SUCCESS";
    bidAndWinActions["GET_BID_AND_WIN_ERROR"] = "GET_BID_AND_WIN_ERROR";
    bidAndWinActions["ENTER_BID_AND_WIN_REQUEST"] = "ENTER_BID_AND_WIN_REQUEST";
    bidAndWinActions["ENTER_BID_AND_WIN_SUCCESS"] = "ENTER_BID_AND_WIN_SUCCESS";
    bidAndWinActions["ENTER_BID_AND_WIN_ERROR"] = "ENTER_BID_AND_WIN_ERROR";
    bidAndWinActions["PLACE_BID_REQUEST"] = "PLACE_BID_REQUEST";
    bidAndWinActions["PLACE_BID_SUCCESS"] = "PLACE_BID_SUCCESS";
    bidAndWinActions["PLACE_BID_ERROR"] = "PLACE_BID_ERROR";
    bidAndWinActions["CLAIM_BID_POINT_REQUEST"] = "CLAIM_BID_POINT_REQUEST";
    bidAndWinActions["CLAIM_BID_POINT_SUCCESS"] = "CLAIM_BID_POINT_SUCCESS";
    bidAndWinActions["CLAIM_BID_POINT_ERROR"] = "CLAIM_BID_POINT_ERROR";
    bidAndWinActions["GET_BID_AND_WIN_WINNERS_REQUEST"] = "GET_BID_AND_WIN_WINNERS_REQUEST";
    bidAndWinActions["GET_BID_AND_WIN_WINNERS_SUCCESS"] = "GET_BID_AND_WIN_WINNERS_SUCCESS";
    bidAndWinActions["GET_BID_AND_WIN_WINNERS_ERROR"] = "GET_BID_AND_WIN_WINNERS_ERROR";
})(bidAndWinActions || (bidAndWinActions = {}));
export function getBidAndWinRequest() {
    return (dispatch) => {
        dispatch({
            type: bidAndWinActions.GET_BID_AND_WIN_REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            headers
        }, {
            pathname: '/api/1/bid-and-win/campaign/user-campaign-summary',
            action: bidAndWinActions.GET_BID_AND_WIN_REQUEST
        })).then(json => dispatch({
            type: bidAndWinActions.GET_BID_AND_WIN_SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: bidAndWinActions.GET_BID_AND_WIN_ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
export function enterBidAndWinRequest() {
    return (dispatch) => {
        dispatch({
            type: bidAndWinActions.ENTER_BID_AND_WIN_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers
        }, {
            pathname: '/api/1/bid-and-win/campaign/enter',
            action: bidAndWinActions.ENTER_BID_AND_WIN_REQUEST
        }), {}).then(json => dispatch({
            type: bidAndWinActions.ENTER_BID_AND_WIN_SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: bidAndWinActions.ENTER_BID_AND_WIN_ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
export function placeBidRequest(params) {
    return (dispatch) => {
        dispatch({
            type: bidAndWinActions.PLACE_BID_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers
        }, {
            pathname: '/api/1/bid-and-win/campaign/place-bid',
            action: bidAndWinActions.PLACE_BID_REQUEST,
            acceptErrors: true
        }), params).then(json => dispatch({
            type: bidAndWinActions.PLACE_BID_SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: bidAndWinActions.PLACE_BID_ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
export function claimBidPointRequest(campaignId, actionId) {
    return (dispatch) => {
        dispatch({
            type: bidAndWinActions.CLAIM_BID_POINT_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers
        }, {
            pathname: '/api/1/bid-and-win/campaign/action',
            action: bidAndWinActions.CLAIM_BID_POINT_REQUEST
        }), { campaignId, actionId }).then(json => dispatch({
            type: bidAndWinActions.CLAIM_BID_POINT_SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: bidAndWinActions.CLAIM_BID_POINT_ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
export function getBidAndWinWinnersRequest() {
    return (dispatch) => {
        dispatch({
            type: bidAndWinActions.GET_BID_AND_WIN_WINNERS_REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            headers
        }, {
            pathname: '/api/1/bid-and-win/winners',
            action: bidAndWinActions.GET_BID_AND_WIN_WINNERS_REQUEST
        })).then(json => dispatch({
            type: bidAndWinActions.GET_BID_AND_WIN_WINNERS_SUCCESS,
            data: { data: json.RESPONSE }
        }), error => {
            dispatch({
                type: bidAndWinActions.GET_BID_AND_WIN_WINNERS_ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
